<template>
  <div class="gift-box">
    <!-- 购物车、结算页、订单页赠品 -->
    <div :class="['g-type2', { 'shop-cart': type == 'shopcart' }]" v-if="giftList.length > 0">
      <div
        class="g-content g-horizontal"
        @click.stop="toggleShowPop"
        v-track="[
          {
            act: 'click',
            params: {
              cfrom: customParams.click,
              event_id: customParams.click,
              sku_id: customParams.sku_id,
              page_name: customParams.page_name,
              isno_choose: optionGifts.length ? 1 : 0
            }
          },
          {
            act: 'show',
            params: {
              cfrom: customParams.show,
              event_id: customParams.show,
              sku_id: customParams.sku_id,
              page_name: customParams.page_name,
              isno_choose: optionGifts.length ? 1 : 0
            }
          }
        ]"
      >
        <v-button size="small" type="frame" lineColor="#535353" color="#222" v-track="trackGiftData(1)">赠品</v-button>
        <ul class="g-list" v-if="!isShowList">
          <li v-for="(item, index) in outerGifts" :key="index" v-track="trackGiftData(2, item)">
            <!-- 收起状态最多展示4条数据 -->
            <img v-lazy="item.smallPic || item.thumbnailPic" alt="" />
            <div
              :class="[
                'g-type',
                {
                  'type-hour': item.giftType == 43
                }
              ]"
              v-if="showTypeIcon && item.giftType"
            >
              <img class="g-type-icon" :src="item.levelIconUrl" v-if="item.giftType == 42 && item.vipGiftLevel" />
            </div>
          </li>
        </ul>
        <div class="g-cnt" v-if="!isShowList">{{ giftRightNameChange }}</div>
        <v-icon v-if="!isShowList" name="arrow-down" class="g-arrow" />
        <v-icon v-else name="arrow-up" class="g-arrow" />
      </div>
      <collapse>
        <div class="g-vertical" v-if="isShowList">
          <span class="g-tips fs-36 c-88" v-if="tips" v-track="tipsTrack">{{ tips }}</span>
          <div class="optional-module" v-if="optionalList.length">
            <div
              class="module"
              v-for="item in optionalList"
              :key="item.optionalGiftId"
              :ref="`option${item.optionalGiftId}`"
              :class="{ 'option-remind': optionRemind && unFullSelectedIds.includes(item.optionalGiftId) }"
            >
              <OptionalGifts
                :list="item.list"
                :optionalGiftId="item.optionalGiftId"
                :selectNums="item.selectNums"
                :showTypeIcon="showTypeIcon"
                :skuId="customParams.sku_id"
                :customParams="customParams"
                @select="handleGiftSelect"
              ></OptionalGifts>
            </div>
          </div>
          <ul :class="['normal-module', { border1px: optionalList.length }]" v-if="normalGifts.length">
            <li class="normal-item" v-for="(item, index) in normalGifts" :key="index">
              <GiftItem
                :skuId="customParams.sku_id"
                :item="item"
                :showTypeIcon="showTypeIcon"
                :positionKey="index"
                :customParams="customParams"
              ></GiftItem>
            </li>
          </ul>
        </div>
      </collapse>
    </div>
  </div>
</template>

<script>
import env from 'utils/clientEnv'
import giftEventBus from '@/utils/eventBus'
import GiftItem from './components/gift-item'
import OptionalGifts from './components/optional-gifts'

export default {
  name: 'Gift',
  components: {
    GiftItem,
    OptionalGifts
  },
  props: {
    gList: [String, Object, Array],
    showTypeIcon: {
      type: Boolean,
      default: false
    },
    customParams: Object,
    // 兼容购物车的赠品展示样式，赠品一行展示最大宽度调小
    type: String,
    giftShowOpt: [Number, String], // 结算页赠品行是否展开
    tips: String // 提示信息栏
  },
  data() {
    return {
      env,
      giftsArr: [],
      isShowList: this.giftShowOpt == 1, // 赠品弹层列表是否展示
      unFullSelectedIds: [], // 未选满可选赠品的活动id
      firstGiftId: '', // 首个未选满的可选活动
      optionRemind: false // 是否高亮提示
    }
  },
  mounted() {
    if (this.type == 'confirm') {
      giftEventBus.$on('giftReSelct', () => {
        this.handleOptionRemind()
      })
      giftEventBus.$on('promotionChange', () => {
        this.handlePromotionChange()
      })
    }
  },
  computed: {
    giftList() {
      // 赠品字段统一化
      let giftList = this.giftsArr
      giftList.forEach(item => {
        if (!item.vipGiftLevel && item.commodityAttrs && item.commodityAttrs.vipGiftLevel) {
          item.vipGiftLevel = item.commodityAttrs.vipGiftLevel
        }
        item.quantity && (item.num = item.quantity)
        item.commodityName && (item.name = item.commodityName)
        item.commodityImgUrl && (item.thumbnailPic = item.commodityImgUrl)
        item.commoditySkuId && (item.skuId = item.commoditySkuId)
        item.giftSkuId && (item.skuId = item.giftSkuId)
        item.id && (item.skuId = item.id)
        item.commoditySpuId && (item.spuId = item.commoditySpuId)
      })
      return giftList
    },
    // 赠品行赠品
    outerGifts() {
      return this.type == 'confirm'
        ? this.giftList.filter(item => !item.optionalGiftId || item.canOptional == 1)
        : this.giftList
    },
    // 可选赠品活动列表
    optionalList() {
      return this.optionGiftsChange(this.optionGifts)
    },
    // 可选赠品
    optionGifts() {
      return this.type == 'confirm' ? this.giftList.filter(item => item.optionalGiftId) : []
    },
    // 非可选赠品
    normalGifts() {
      return this.type == 'confirm' ? this.giftList.filter(item => !item.optionalGiftId) : this.giftList
    },
    giftRightNameChange() {
      return this.optionGifts?.length ? '挑选' : `共${this.giftsCount}件`
    },
    // 赠品总数
    giftsCount() {
      let count = 0
      this.outerGifts.forEach(item => {
        if (item.num) {
          count += item.num
        } else {
          count++
        }
      })
      return count
    },
    tipsTrack() {
      if (this.type === 'confirm') {
        return {
          act: 'show',
          params: {
            event_id: '083|038|02|077'
          }
        }
      }
    },
    trackGiftData() {
      if (this.type === 'confirm') {
        return (mode, item) => {
          if (mode == 1) {
            return {
              act: 'show',
              params: {
                cfrom: '083|002|02|077',
                event_id: '083|002|02|077',
                sku_id: this.customParams.sku_id,
                gift_qty: this.giftsCount,
                isno_choose: this.optionGifts.length ? 1 : 0
              }
            }
          } else {
            return {
              act: 'show',
              params: {
                cfrom: '083|004|02|077',
                event_id: '083|004|02|077',
                sku_id: this.customParams.sku_id,
                gift_id: item.id,
                gift_name: item.name,
                gift_label: item.giftType,
                isno_choose: item.optionalGiftId ? 1 : 0
              }
            }
          }
        }
      }
      return () => {}
    }
  },
  watch: {
    gList: {
      handler(newVal) {
        this.giftsArr = JSON.parse(JSON.stringify(newVal))
      },
      immediate: true,
      deep: true
    },
    optionGifts: {
      handler() {
        if (this.type == 'confirm') {
          this.updateGiftId()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 赠品弹层展示隐藏处理
    toggleShowPop() {
      if (this.type == 'confirm') {
        this.$track({
          cfrom: '083|003|01|077',
          event_id: '083|003|01|077',
          status: this.isShowList ? 0 : 1,
          sku_id: this.customParams.sku_id,
          isno_choose: this.optionGifts.length ? 1 : 0
        })
      }
      this.optionRemind = false
      this.isShowList = !this.isShowList
    },
    optionGiftsChange(list) {
      let arr = [...new Set(list.map(v => v.optionalGiftId))]
      let options = []
      arr.forEach(item => {
        let obj = {}
        obj.optionalGiftId = item
        obj.list = list.filter(v => v.optionalGiftId == item)
        obj.selectNums = obj.list[0].allOpCount // 最大可选数目
        obj.remainNums = obj.selectNums - obj.list.filter(v => v.canOptional == 1).length // 剩余可选数目
        obj.fullSelected = obj.list.filter(v => v.canOptional == 1).length == obj.selectNums // 是否已选满可选赠品
        options.push(obj)
      })
      this.unFullSelectedIds = options.filter(item => !item.fullSelected).map(item => item.optionalGiftId)
      this.firstGiftId = this.unFullSelectedIds.length
        ? options.filter(item => !item.fullSelected)[0].optionalGiftId
        : ''
      return options
    },
    handleGiftSelect(optionalGiftId, selectIdList) {
      this.optionalList
        .find(item => item.optionalGiftId == optionalGiftId)
        .list.forEach(item => {
          if (selectIdList.includes(item.id)) {
            item.canOptional = 1
          } else {
            item.canOptional = 0
          }
        })
      this.optionRemind = false
    },
    updateGiftId() {
      if (this.optionalList.length) {
        let obj = {
          skuId: this.customParams.sku_id,
          giftIds: '',
          remainNums: this.optionalList.map(item => item.remainNums).reduce((total, num) => total + num, 0), // 剩余可选赠品总数
          fullSelected: !this.unFullSelectedIds.length, // 可选赠品是否选满
          isShowList: this.isShowList
        }
        let giftIds = []
        this.optionalList.forEach(item => {
          let arr = item.list.filter(v => v.canOptional == 1).map(v => item.optionalGiftId + v.id)
          giftIds = giftIds.concat(arr.length ? arr : [item.optionalGiftId + 'none'])
        })
        obj.giftIds = giftIds.join(',')
        this.$emit('optionGiftChange', obj)
      } else {
        let obj = {
          skuId: this.customParams.sku_id,
          giftIds: '',
          remainNums: 0,
          fullSelected: true,
          isShowList: this.isShowList
        }
        this.$emit('optionGiftChange', obj)
      }
    },
    handleOptionRemind() {
      if (this.unFullSelectedIds.length) {
        // 为了重新加载动画效果先移除样式
        this.optionRemind = false
        this.isShowList = true
        if (this.firstGiftId) {
          this.$nextTick(() => {
            if (this.$refs['option' + this.firstGiftId]?.[0]) {
              this.optionRemind = true
              this.$refs['option' + this.firstGiftId][0].scrollIntoView()
            }
          })
        }
      }
    },
    handlePromotionChange() {
      this.$nextTick(() => {
        // 赠品活动发生变化展开赠品行
        if (this.giftShowOpt == 1) {
          this.isShowList = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
